import {EFieldType} from 'entities/metadata';

export interface IUseFieldLabelProps {
    type: EFieldType;
    label?: string;
    hideLabel?: boolean;
}

export const useFieldLabel = ({type, hideLabel, label}: IUseFieldLabelProps) => {
    const isFieldWithoutLabel = [
        EFieldType.BOOLEAN,
        EFieldType.FIELD_BLOCK,
        EFieldType.FILE_LIST_WITH_SIGNS,
        EFieldType.EXTERNAL_EMPLOYEE_BOOL,
        EFieldType.TIME_WITH_LABEL_INSIDE,
        EFieldType.INPUT_WITH_DEFAULT_VALUE_SETTER,
    ].includes(type);

    const computedLabel = (hideLabel || isFieldWithoutLabel) ? undefined : label;

    return {label: computedLabel};
};
